import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import cookie from "react-cookies";
import queryString from "query-string";

import { login } from "../../model/profile";

import { getLoggedProfile } from "../../actions/sessionAct";
import { commonErr } from "../common/errors";

import { LoadingInline } from "../common/loading";

import ResetPwByEmail from "../account/resetpwbyemail";
import VerifyPhoneOpt from "../account/verifyphoneopt";
import VerifyPhoneOptBreak from "../account/verifyphoneoptbreak";

import { otpAction, otpMethod } from "../common/common";
import { CustomInputLabelOutside } from "../components/input";
import { ResetPwForm, ForgotPasswordForm } from "../login/login";

import bg from "../../static/images/login/background.png";
import bg_line from "../../static/images/login/background-line.svg";
import logo from "../../static/images/login/logo-white.png";
import login_vector from "../../static/images/login/login.svg";

import { IcPassword, IcEye, Success} from "../common/svg";


const RedirectBox = ({show, url, onClose, onRedirectUrl, auto}) => {
	return (
			<Modal
			show={show}
			dialogClassName={`modal-s modal-dialog modal-confirm`}>
				<Modal.Header closeButton={false} closeLabel={""} >
				</Modal.Header>
				<Modal.Body>
					<div className="modal-confirm-body confirm-inner">
						{!auto ? <>
							<div className="wrap-svg">
								<Success />
							</div> 
							<h6>Đăng nhập thành công</h6> 
						</>
						:  
						<h5>Thông báo</h5>}
						<p className="font-14">Hệ thống sẽ chuyển hướng sang {url}. Bạn có muốn tiếp tục?</p>
						<div className="wrap-btn">
							<a className="btn btn--m btn-primary" onClick={onRedirectUrl}>Tiếp tục</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
	)
}

class LoginPage extends React.Component {
	constructor(props) {
		super(props);
		cookie.save("_mcookietest", "_mcookietest", { path: "/" });
		const mcookietest = cookie.load("_mcookietest");
		cookie.remove("_mcookietest");
		this.state = {
			ip_username: "",
			ip_password: "",
			err: commonErr.INNIT,
			errMsg: "",

			resetPwPhone: "",
			resetAccessTok: "",
			showResetPwForm: false,
			isCookieAllowed:
				mcookietest !== undefined &&
				mcookietest !== null &&
				mcookietest !== "",
			url: "",
			inputType: "password",
			isShowRedirectBox: false
		};
	}

	componentDidMount() {
		//overide filter by query params
		let url;
		const currentUrl = window.location.origin;

		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);

			if (query.redirect) {
				this.setState({
					url: query.redirect,
				});
			}
		} else {
			this.setState({
				url: currentUrl,
			});
		}

		if (this.props.session.profile.err === commonErr.INNIT) {
			this.props.dispatch(getLoggedProfile());
		}
		
	
	}
	

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.onLoginBtnClick();
		}
	};

	onLoginBtnClick = (event) => {
		const username = this.state.ip_username;
		const password = this.state.ip_password;

		const { url } = this.state;

		if (username !== "" && password !== "") {
			this.setState({ err: commonErr.LOADING });
			login(username, password).then((resp) => {

				if (resp.data.error == -40212) {
					// required otp
					this.showVerifyLoginPhoneOpt(username);
					return;
				}

				if (resp.data.error >= commonErr.SUCCESS) {
					if (url !== "") {
						this.showRedirectBox()
					}
					this.getLoggedProfile();
				}
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
				
			});
		}
	};

	onRedirectUrl = () => {
		const { url } = this.state;
		if (url !== "") {
			window.location.assign(url);
		}
	}

	showForgotPasswordForm = () => {
		this.setState({
			isShowForgotPasswordForm: true,
		});
	};

	hideForgotPasswordForm = () => {
		this.setState({
			isShowForgotPasswordForm: false,
		});
	};

	showVerifyPhoneOpt = (phone) => {
		this.setState({
			forgotPasswordWithPhoneNumber: phone,
			showVerifyPhoneOpt: true,
		});
	};

	showVerifyLoginPhoneOpt = (phone) => {
		this.setState({
			forgotPasswordWithPhoneNumber: phone,
			showVerifyLoginPhoneOpt: true,
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: false,
		});
	};

	hideVerifyLoginPhoneOpt = () => {
		this.setState({
			showVerifyLoginPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: false,
		});
	};

	hideResetPwForm = () => {
		this.setState({
			showResetPwForm: false,
			resetPwPhone: "",
			resetAccessTok: "",
		});
	};

	onVerifyPhoneOptSuccess = (data) => {
		this.setState({
			showResetPwForm: true,
			otpData: data,
		});
	};

	showVerifyEmail = (email) => {
		this.setState({
			isShowVerifyEmail: true,
			isShowForgotPasswordForm: false,
			emailForReset: email,
		});
	};

	hideVerifyEmail = () => {
		this.setState({
			isShowVerifyEmail: false,
		});
	};

	showRedirectBox = () => {
		this.setState({
			isShowRedirectBox: true
		})
	}

	hideRedirectBox = () => {
		this.setState({
			isShowRedirectBox: false
		})
	}

	onBackBtnClick = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	toggleInput = () => {
		const { inputType } = this.state;
		this.setState({
			inputType: inputType === "password" ? "text" : "password",
			[`${name}`]: name === "password" ? "text" : "password",
		});
	};

	renderPw = () => {
		const { inputType } = this.state;

		return (
			<div className="wrap-svg" onClick={this.toggleInput}>
				{inputType === "password" ? <IcPassword /> : <IcEye />}
			</div>
		);
	};

	render() {
		const {
			isCookieAllowed,
			err,
			errMsg,
			url,
			inputType,
			isShowForgotPasswordForm,
			isShowRedirectBox,
			showVerifyPhoneOpt,
			showVerifyLoginPhoneOpt,
			showVerifyPhoneOptBreak,
			forgotPasswordWithPhoneNumber,
			showResetPwForm,
			isShowVerifyEmail,
			otpData,
			emailForReset,
			ip_password,
		} = this.state;
		var content;
		var autoShowBox;

		if (this.props.session.profile.err === commonErr.SUCCESS
			&& (this.props.session.profile
				&& this.props.session.profile.info
				&& this.props.session.profile.info.uid && !isShowRedirectBox)) {
				autoShowBox = <RedirectBox auto={true} show={true} url={url} onClose={this.hideRedirectBox} onRedirectUrl={this.onRedirectUrl} />
		} else {
			autoShowBox = null
		}

		if (!isCookieAllowed) {
			content = (
				<p className="textAlign-center">
					Bạn cần cài đặt trình duyệt cho phép sử dụng cookies mới có
					thể đăng nhập hệ thống.
				</p>
			);
		} else if (err != commonErr.SUCCESS && errMsg !== "") {
			content = (
				<React.Fragment>
					<div className="space m"></div>
					<p className="textAlign-center">{errMsg}</p>
					<div className="space m"></div>
					<a
						className="btn btn--m btn-primary"
						onClick={this.onBackBtnClick}>
						Thử lại
					</a>
				</React.Fragment>
			);
		} else {
			content = (
				<React.Fragment>
					<div className="input-form">
						<CustomInputLabelOutside
							type={`text`}
							name={`ip_username`}
							label={`Tên đăng nhập`}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleInputChange}
						/>
						<CustomInputLabelOutside
							type={inputType}
							name={`ip_password`}
							label={`Mật khẩu`}
							onChange={this.handleInputChange}
							onKeyPress={this.handleKeyPress}
							icRight={this.renderPw()}
						/>
						<div className="wrap-forgot">
							<p
								className="forgot-pass"
								onClick={this.showForgotPasswordForm}>
								Quên mật khẩu?
							</p>
						</div>
					</div>
					<a
						className="btn btn--m btn-primary"
						onClick={this.onLoginBtnClick}>
						{err === commonErr.LOADING ? (
							<LoadingInline />
						) : (
							`Đăng nhập`
						)}
					</a>
				</React.Fragment>
			);
		}
		return (
			<div className="mioto-layout">
				<section className="body">
					<div
						className="login-section"
						style={{ backgroundImage: `url(${bg})` }}>
						<div
							className="background-line"
							style={{ backgroundImage: `url(${bg_line})` }}
						/>
						<div className="m-container">
							<div className="login-container">
								<div className="text-form">
									<img loading="lazy" src={logo} />
									<h1>Cùng Bạn Đến Mọi Hành&nbsp;Trình</h1>
								</div>
								<div className="login-form">
									<h5 className="textAlign-center">
										Đăng nhập
									</h5>
									<img loading="lazy" src={login_vector} />
									{content}
								</div>
							</div>
						</div>

						<ForgotPasswordForm
							isShow={isShowForgotPasswordForm}
							hide={this.hideForgotPasswordForm}
							showVerifyEmail={this.showVerifyEmail}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>

						{showVerifyPhoneOpt && (
							<VerifyPhoneOpt
								show={showVerifyPhoneOpt}
								hideModal={this.hideVerifyPhoneOpt}
								phoneNumber={forgotPasswordWithPhoneNumber}
								action={otpAction.TOA_RECOVER_PASSWORD}
								onVerifyPhoneOptSuccess={
									this.onVerifyPhoneOptSuccess
								}
								onBreakVerifyPhoneOtp={
									this.showVerifyPhoneOptBreak
								}
							/>
						)}
						{showVerifyLoginPhoneOpt && (
							<VerifyPhoneOpt
								show={showVerifyLoginPhoneOpt}
								hideModal={this.hideVerifyLoginPhoneOpt}
								phoneNumber={forgotPasswordWithPhoneNumber}
								pwd={ip_password}
								action={otpAction.TOA_VERIFY_LOGIN}
								onVerifyPhoneOptSuccess={
									this.onVerifyPhoneOptSuccess
								}
								onBreakVerifyPhoneOtp={
									this.showVerifyPhoneOptBreak
								}
								getLoggedProfile={this.getLoggedProfile}
								url={url}
							/>
						)}
						{showVerifyPhoneOptBreak && (
							<VerifyPhoneOptBreak
								show={showVerifyPhoneOptBreak}
								hideModal={this.hideVerifyPhoneOptBreak}
							/>
						)}
						<ResetPwForm
							show={showResetPwForm}
							hideModal={this.hideResetPwForm}
							hideForgotPasswordForm={this.hideForgotPasswordForm}
							otpData={otpData}
						/>
						{isShowVerifyEmail && (
							<ResetPwByEmail
								show={isShowVerifyEmail}
								hideModal={this.hideVerifyEmail}
								showLoginModal={this.props.showModal}
								email={emailForReset}
							/>
						)}

						{autoShowBox}

						<RedirectBox show={isShowRedirectBox} url={url} onClose={this.hideRedirectBox} onRedirectUrl={this.onRedirectUrl} />
					</div>
				</section>
			</div>
		);
	}
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}

LoginPage = connect(mapSessionState)(LoginPage);

export default LoginPage;
